module.exports = {"611025001":"永乐街道","611025101":"回龙镇","611025102":"铁厂镇","611025103":"大坪镇","611025104":"米粮镇","611025105":"茅坪回族镇","611025106":"西口回族镇","611025107":"高峰镇","611025108":"青铜关镇","611025109":"柴坪镇","611025110":"达仁镇","611025111":"木王镇","611025113":"云盖寺镇","611025114":"庙沟镇","611025117":"月河镇","611025400":"黑窑沟林厂","611025401":"木王林厂","611025402":"镇安县苗圃"}


//////////////////
// WEBPACK FOOTER
// ./src/town/611025.json
// module id = 2677
// module chunks = 0